"use client";

import { useTranslation } from "react-i18next";
import { Copyright } from "lucide-react";

// RTK: mailto placeholder until the notice-and-takedown form ships — the
// receiving mailbox must be confirmed before commercial launch.
const REPORT_HREF =
  "mailto:copyright@i-screamedu.co.kr?subject=Copyright%20infringement%20report";

export function ReportCopyrightLink({
  collapsed = false,
}: {
  collapsed?: boolean;
}) {
  const { t } = useTranslation();
  const label = t("Report copyright infringement");

  if (collapsed) {
    return (
      <a
        href={REPORT_HREF}
        className="rounded-lg p-2 text-[var(--muted-foreground)] transition-colors hover:bg-[var(--background)]/50 hover:text-[var(--foreground)]"
        aria-label={label}
        title={label}
      >
        <Copyright size={18} strokeWidth={1.7} />
      </a>
    );
  }

  return (
    <a
      href={REPORT_HREF}
      className="flex w-full items-center gap-2.5 rounded-lg px-3 py-2 text-[13.5px] text-[var(--muted-foreground)] transition-colors hover:bg-[var(--background)]/50 hover:text-[var(--foreground)]"
      title={label}
    >
      <Copyright size={16} strokeWidth={1.7} />
      <span className="truncate">{label}</span>
    </a>
  );
}
